import { useMutation, useQueryClient } from "@tanstack/react-query";
import { alertService } from "../../../services/alertsService";
import type { Alert } from "../../../types";

export const useCreateAlert = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (input: Omit<Alert, "id">) => alertService.create(input),
    onSuccess: () => {
      qc.invalidateQueries({queryKey: ["alerts"]});
    },
  });
};
